export default {
  PRODUCT_BY_OWNER_FETCHED: 'PRODUCT_BY_OWNER_FETCHED',
  PRODUCT_BY_OWNER_LOAD: 'PRODUCT_BY_OWNER_LOAD',
  PRODUCT_BY_OWNER_DETAIL_FETCHED: 'PRODUCT_BY_OWNER_DETAIL_FETCHED',
  PRODUCT_BY_OWNER_DETAIL_LOAD: 'PRODUCT_BY_OWNER_DETAIL_LOAD',
  PRODUCT_BY_OWNER_SET_PAGE: 'PRODUCT_BY_OWNER_SET_PAGE',
};
